<template>
  <div class="page-scene">
    <div class="page-scene-wrap">
      <img
        class="scene"
        src="./../../assets/image/simulation/scene.png"
        alt=""
      />
      <el-tooltip
        class="item"
        effect="light"
        placement="top-end"
        :value="showTrue"
        :manual="true"
      >
        <div slot="content">
          <span style="font-size: 14px">点击解答</span>
          <img
            src="./../../assets/image/simulation/txt1.png"
            alt=""
            width="120"
          />
          <span style="font-size: 14px">问题</span>
        </div>
        <img
          @click="people_1.show = true"
          class="exclamation show-big people-2"
          src="./../../assets/image/simulation/exclamation.png"
          alt=""
        />
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="light"
        placement="top-start"
        :value="showTrue"
        :manual="true"
      >
        <div slot="content">
          <span style="font-size: 14px">点击解答</span>
          <img
            src="./../../assets/image/simulation/txt3.png"
            alt=""
            width="120"
          />
          <span style="font-size: 14px">问题</span>
        </div>
        <img
          @click="people_2.show = true"
          class="question show-big people-1"
          src="./../../assets/image/simulation/question.png"
          alt=""
        />
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="light"
        placement="top-start"
        :value="showTrue"
        :manual="true"
      >
        <div slot="content">
          <span style="font-size: 14px">点击解答</span>
          <img
            src="./../../assets/image/simulation/txt2.png"
            alt=""
            width="120"
          />
          <span style="font-size: 14px">问题</span>
        </div>
        <img
          @click="people_3.show = true"
          class="exclamation show-big people-4"
          src="./../../assets/image/simulation/exclamation.png"
          alt=""
        />
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="light"
        placement="top-end"
        :value="showTrue"
        :manual="true"
      >
        <div slot="content">
          <span style="font-size: 14px">点击解答</span>
          <img
            src="./../../assets/image/simulation/txt4.png"
            alt=""
            width="120"
          />
          <span style="font-size: 14px">问题</span>
        </div>
        <img
          @click="people_4.show = true"
          class="question show-big people-3"
          src="./../../assets/image/simulation/question.png"
          alt=""
        />
      </el-tooltip>
    </div>
    <chart-component0
      :chartIndex="chartIndex"
      @finish="(index) => (this.chartIndex = index)"
    ></chart-component0>
    <chart-component1
      :chartIndex="chartIndex"
      @finish="(index) => (this.chartIndex = index)"
    ></chart-component1>
    <chart-component2
      :chartIndex="chartIndex"
      @finish="(index) => (this.chartIndex = index)"
    ></chart-component2>
    <chart-component3
      :show="people_1.show"
      @close="people_1.show = false"
      @finish="$emit('changeData')"
    ></chart-component3>
    <chart-component4
      :show="people_2.show"
      @close="people_2.show = false"
      @finish="$emit('changeData')"
    ></chart-component4>
    <chart-component5
      :show="people_3.show"
      @close="people_3.show = false"
      @finish="$emit('changeData')"
    ></chart-component5>
    <chart-component6
      :show="people_4.show"
      @close="people_4.show = false"
      @finish="$emit('changeData')"
    ></chart-component6>
  </div>
</template>

<script>
import chartComponent0 from "./components/chartComponent0";
import chartComponent1 from "./components/chartComponent1";
import chartComponent2 from "./components/chartComponent2";
import chartComponent3 from "./components/chartComponent3";
import chartComponent4 from "./components/chartComponent4";
import chartComponent5 from "./components/chartComponent5";
import chartComponent6 from "./components/chartComponent6";
export default {
  name: "scene",
  components: {
    chartComponent0,
    chartComponent1,
    chartComponent2,
    chartComponent3,
    chartComponent4,
    chartComponent5,
    chartComponent6,
  },
  data() {
    return {
      chartIndex: -2,
      people_1: {
        resolve: false,
        show: false,
      },
      people_2: {
        resolve: false,
        show: false,
      },
      people_3: {
        resolve: false,
        show: false,
      },
      people_4: {
        resolve: false,
        show: false,
      },
      showTrue: false,
    };
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.chartIndex += 1;
      this.showTrue = true;
    }, 1000);
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.cursorPointer {
  cursor: pointer;
}
.page-scene {
  width: 100%;
  height: 100%;
  .page-scene-wrap {
    position: relative;
    width: 896px;
    height: 860px;
    > img.scene {
      width: 896px;
      height: 860px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}

.people-state {
  position: absolute;
}

img.question.people-1 {
  cursor: pointer;
  position: absolute;
  left: 440px;
  bottom: 548px;
  width: 18px;
  padding: 10px;
  box-sizing: content-box;
}
img.exclamation.people-2 {
  cursor: pointer;
  position: absolute;
  left: 264px;
  bottom: 478px;
  width: 30px;
  padding: 10px;
}
img.question.people-3 {
  cursor: pointer;
  position: absolute;
  left: 488px;
  bottom: 354px;
  width: 18px;
  padding: 10px;
  box-sizing: content-box;
}
img.exclamation.people-4 {
  cursor: pointer;
  position: absolute;
  left: 672px;
  bottom: 416px;
  width: 30px;
  padding: 10px;
}

.chart-small-1 {
  &:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    bottom: 14px;
    right: 0;
    border-left: 40px solid transparent;
    border-right: 24px solid transparent;
    border-top: 16px solid teal;
    transform: skewX(66deg);
  }
  position: absolute;
  right: 666px;
  bottom: 458px;
  z-index: 3;
  width: 130px;
  height: 100px;
  backdrop-filter: drop-shadow(7px 5px 6px black);
  color: #ffffff;
  font-size: 16px;
  font-weight: bolder;
  font-family: fangsong, sans-serif;
  background: #008080;
  border-radius: 50%;
}
</style>
